<template>
  <div :class="{ 'text-grey-responsive-7': !props.value }">
    <i18n-n
      v-if="$_.isNumber(props.value)"
      :value="props.value"
      format="currency"
      scope="global"
    />
    <template v-else-if="$_.isObject(props.value) && $_.isNumber(props.value.amount)">
      <i18n-n
        :value="props.value && props.value.amount"
        format="currency"
        scope="global"
      />
      <q-chip
        v-if="props.value.count"
        class="q-ml-sm"
        color="grey-7"
        text-color="white"
        size="sm"
        square
        dense
        :label="props.value.count"
      />
    </template>
    <span v-else>—</span>
  </div>
</template>

<script>
import TableCellMixin from 'src/modules/admin/components/model-table/components/TableCellMixin'

export default {
  name: 'MoneyCell',
  mixins: [TableCellMixin]
}
</script>
